// extracted by mini-css-extract-plugin
export var attribution = "_d7-4";
export var authorName = "_d7-5";
export var quote = "_d7-3";
export var testimonial = "_d7-2";
export var trustedBy = "_d7-0";
export var trustedByLabel = "_d7-1";